import { getApiActionTypes } from '../storeHelpers';

export const fetchConstantsTypes = getApiActionTypes('FETCH_CONSTANTS');
export const deleteConstantsTypes = getApiActionTypes('DELETE_CONSTANTS');
export const createConstantTypes = getApiActionTypes('CREATE_CONSTANT');
export const updateConstantTypes = getApiActionTypes('UPDATE_CONSTANT');
export const SELECT_CONSTANT_TYPE = 'SELECT_CONSTANT_TYPE';
export const SELECT_CONSTANTS_PERIOD = 'SELECT_CONSTANTS_PERIOD';
